import { FormikHelpers, FormikValues } from 'formik';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { object, string } from 'yup';

import Buscando from 'Component/Admin/Buscando';
import Cabecalho from 'Component/Admin/Cabecalho';
import SemRegistros from 'Component/Admin/SemRegistros';
import { SolicitacaoLista } from 'Component/Admin/Solicitacao';
import Botao from 'Component/Botao';
import Form, { Campo, Selecao } from 'Component/Form';
import Paginacao from 'Component/Paginacao';
import { STATUS_SOLICITACAO } from 'View/constants';
import { useRecuperarSolicitacoesQuery } from 'View/Service/Default/Solicitacoes';

interface Filtro {
  busca?: string;
  status?: 0 | 1 | 2;
}

const regras = object({
  busca: string().optional().min(3, 'Deve ter mais que 3 letras'),
});

const Default = (): React.ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    data: { solicitacoes, paginacao } = {},
    refetch,
    isFetching,
    isLoading,
  } = useRecuperarSolicitacoesQuery({
    contain: ['Atendentes', 'Clientes'],
    options: {
      busca: { termo: searchParams.get('busca') || '' },
      status: searchParams.get('status') || '',
    },
    page: searchParams.get('pagina') || 1,
    scope: false,
  });

  const filtrar = (dados: Filtro, form: FormikHelpers<FormikValues>) => {
    if (dados.busca) {
      searchParams.set('busca', dados.busca);
    } else {
      searchParams.delete('busca');
    }
    if (dados.status) {
      searchParams.set('status', dados.status.toString());
    } else {
      searchParams.delete('status');
    }

    setSearchParams(searchParams);

    form.setSubmitting(false);
  };

  return (
    <div className="animate__animated animate__fadeIn">
      <Cabecalho
        titulo="Solicitações"
        descricao="Listagem de solicitações abertas pelos alunos"
      />
      <Form
        emLinha
        onSubmit={filtrar}
        regras={regras}
        desabilitado={isFetching}
      >
        <div className="row">
          <div className="col-md-6 mb-3">
            <Botao icone="arrow-clockwise" onClick={refetch} />
          </div>
          <div className="col-md-6 mb-3">
            <div className="hstack gap-3">
              <Selecao
                name="status"
                opcoes={STATUS_SOLICITACAO}
                padrao="Status"
              />
              <Campo
                name="busca"
                rotulo="Digite o que deseja bucar"
                semMargem
              />
              <Botao type="submit" icone="filter" />
            </div>
          </div>
        </div>
      </Form>
      <Buscando exibir={isLoading} />
      <SemRegistros carregando={isLoading} registros={solicitacoes?.length} />
      <div className="bg-white shadow-sm rounded">
        {solicitacoes?.map((solicitacao) => (
          <SolicitacaoLista
            key={`${solicitacao.id}-${solicitacao.modificado}`}
            dados={solicitacao}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </div>
  );
};

export default Default;
